// extracted by mini-css-extract-plugin
export default {"label":"RouteToDot_label__Ark5m","label2":"RouteToDot_label2__fflxO","note":"RouteToDot_note__jxNuW"};